export enum API_ENDPOINTS {
	register = '/auth/sign-up',
	login = '/auth/sign-in',
	resetPassword = '/auth/reset-password',
	passwordRecoveryRequest = '/auth/recover-password',
	verifyBusinessAccount = '/auth/verify-email',
	verifyOtp = '/otp/verify',
	verifyUser = '/users/find-existing-users',
	resendOtp = '/otp/resend',
	getAccountPermission = '/permissions/user/',
	getAccountInfo = '/users/',
	getSectors = '/resources/sectors',
	updateBusinessAccount = '/business/',
	inviteTeamMember = '/invitations',
	activateTeamMember = '/invitations/activate',
	getTeamMembers = '/team/',
	getTeamMember = '/team/member/',
	getStatesWithLGA = '/states-with-lga',
	confirmPassword = '/auth/confirm-password',
	allEmployees = '/customers/employees',
	getEmployee = '/customers/',
	employeeMetrics = '/customers/employee-summary',
	terminateEmployees = '/customers/employees/batch-terminate',
	downloadEmployeesTemplate = '/batch/download-terminate-employee-template',
	computeReactivation = 'customers/activate-terminated-employee-summary',
	reactivateEmployee = 'customers/activate-terminated-employee',
	getInactivePendingPolicies = 'inactive-pending-policies/employees/',
	getAllInvoice = '/invoices',
	getInvoice = '/invoices/',
	getInvoiceMetrics = '/invoices/metrics',
	exportInvoices = 'invoices/export',
	getActivities = '/activities',
	getTodoList = '/todos',
	getAllRoles = '/roles',
	getAllPermissions = '/permissions?user_type=business',
	getRole = '/roles/',
	getCustodianAutoPurchase = '/auto-plans',
	getCustodianGadgetPurchase = '/gadget-plans',
	getTravelCustodianPurchase = '/travel-plans',
	addAutoCustodian = '/purchases/auto/add-custodian',
	addHealthCustodian = '/purchases/health/add-custodian',
	addTravelCustodian = '/purchases/travel/add-custodian',
	addGadgetCustodian = '/purchases/gadget/add-custodian',
	getPendingPolicies = '/pending-policies',
	getPendingPolicy = '/pending-policies/',
	addCustodianWithoutSlot = '/purchases/health/add-custodian-no-slot',
	computeCustodianWithoutSlot = '/purchases/health/compute-add-custodian-no-slot',
	custodiansWithoutSlot = '/purchases/inactive-pending-policies-for-renewal',
	activatePolicy = '/activate/',
	getProducts = '/products/',
	getProductsCategories = '/products/categories/',
	getProductPriceByCoverPeriod = '/products/fetch-price-by-cover-period',
	getProductPriceByMonth = '/products/fetch-price-by-month',
	ComputeAutoFormPriceMiniComprehensive = '/auto/compute-mini-comprehensive-premium',
	ComputeAutoFormPriceThirdParty = '/auto/compute-third-party-premium',
	ComputedComprehensivePrice = '/auto/compute-comprehensive-auto-premium',
	getVehicleTypes = '/vehicles/vehicle-types',
	getVehicleMake = '/vehicles/vehicle-makes',
	getVehicleModel = '/vehicles/vehicle-models/',
	PurchaseAutoVehiclesThirdParty = '/auto/buy-third-party',
	PurchaseAutoVehiclesMiniComprehensive = '/auto/buy-mini-comprehensive',
	PurchaseComprehensiveAuto = '/auto/buy-comprehensive-auto',
	getGadgetCategories = '/gadget/categories',
	getGadgetCategory = '/gadget/categories/',
	getCategoryBrand = '/gadget/categories/brands',
	getGadgetBrands = '/gadget/brands',
	ComputeGadget = '/gadget/compute-gadget-cover-premium/',
	PurchaseGadget = '/gadget/buy-gadget-cover',
	ComputeHealthPurchase = '/health/compute-health-premium',
	PurchaseHealthPlan = '/health/buy-health-plans',
	getTravelLocations = '/travel/locations',
	ComputeTravelPurchase = '/travel/compute-travel-cover-premium',
	PurchaseTravelPlan = '/travel/buy-travel-cover-premium',
	allPurchases = '/purchases',
	purchasesInfo = '/purchases/purchase-summary',
	getPurchasePolicies = '/purchases/=id/policies',
	getPurchaseDetail = '/purchases/=id',
	removePolicySummary = '/policies/remove-summary',
	removePendingPolicySummary = '/pending-policies/remove-summary',
	computeNewDependantSlot = '/purchases/compute-business-add-dependant',
	addNewDependantSlot = '/purchases/business-add-dependant-no-slot',
	updatePeriodOfCover = '/purchases/{payload.plan_id}/edit-cover-period',
	addDependant = '/policies/add-dependant',
	removeDependant = '/policies/remove-dependant',
	purchaseTransactions = '/purchases/=id/transactions',
	purchaseTransaction = '/purchases/=id/transactions/=id',
	planInformation = '/purchases/=id/plan-info',
	getPlanUsageMetrics = '/purchases/=id/plan-usage-overview',
	getPlanUsageRecords = '/purchases/=id/plan-usage-per-policy',
	getPlanUsageChart = '/purchases/=id/claims-comparison',
	getClaimsAnalysis = '/purchases/=id/{plan_category}-claims-analysis',
	planActivitiesOverview = '/purchases/=id/plan-activities-history-overview',
	planActivitiesMetrics = '/purchases/=id/plan-activities',
	planTransactionsHistory = '/purchases/=id/plan-history',
	getPolicyDependants = '/policies/=id/dependants',
	computeDependantSummary = '/policies/remove-dependant-summary',
	fetchInactivePolicies = 'inactive-pending-policies/=id',
	verifyTableUserRecord = '/users/verify-email-phone-link',
	getTitles = '/travel/titles',
	getAiicoTitles = '/aiico-titles',
	AiicoStates = '/comprehensive-auto-states',
	AlianzStates = '/get-allianz-states',
	downloadBatchTemplate = '/batch-purchase/download-policy-template/',
	colorListApi = '/color-list',
	uploadFileApi = '/upload-file',
	documentTypesApi = '/verification-types',
	batchUploadTemplate = 'batch/download-employee-template/',
	relationshipsList = '/resources/relationships',
	getHospitalList = '/hospitals/list',
	getDiscountDetails = '/campaigns/get-by',
	getAmountHistories = '/activities/health-benefits-usage',
	fetchAllEmployeesRecords = 'customers/export',
	validatePlateNumber = 'auto/validate-plate-number',
	validateSerialNumber = 'gadget/validate-serial-number',
	FUND_WALLET = '/wallet/fund',
	SAVE_UNREGISTERED_BUSINESS = '/unregistered-businesses'
}
